<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox" ></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <!-- 添加 -->
      <div class="MobelBox" v-if="addType" >
        <form v-if="detailData.type == 1">
          <div class="write-txt write-item">
            <p class="write-title">
              演讲文件<span>*</span>
            </p>
            <div class="write-text">
              <!-- <audio :src="'https://pic.speechcoach.cn/'+detailData.audio" controls></audio> -->
              <audio ref="audioPlayer" controls class="hide" @timeupdate="updateDuration" @ended="audioEnd">
                <source :src="'https://pic.speechcoach.cn/'+detailData.audio" type="audio/mpeg">
                Your browser does not support the audio element.
              </audio>
              <div class="audio-bg">
                <i v-if="audioType=='play'" class="audio-progress1"></i>
                <i v-else class="audio-progress" v-for="(item,index) in 24" :key="index"></i>
                <p>{{ duration }}</p>
                <span class="audio-type" :class="audioType=='play'?'pause':'play'" @click="playAudio"></span>
              </div>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              简易报告<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('1','1')">测试提示词</button>
              </div>
            </div>
            <div class="write-text">
              <textarea v-model="detailData.ai_simple_comment"></textarea>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              完整报告<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('1','2')">测试提示词</button>
              </div>
            </div>
          </div>
          <div class="write-txt">
            <div class="write-txt" v-for="(item,index) in detailData.dimension" :key="index">
              <p class="write-title">{{item.title}}<span>*</span></p>
              <div class="write-text">
                <input placeholder="" v-model="item.score">
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
          <div class="write-txt write-item">
            <p class="write-title">
              内容分析<span>*</span>
            </p>
            <div class="write-text">
              <textarea v-model="detailData.ai_comment"></textarea>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              声音分析<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('3')">测试提示词</button>
              </div>
            </div>
            <div class="write-text">
              <textarea v-model="detailData.ai_audio_comment"></textarea>
            </div>
          </div>
        </form>
        <form v-else-if="detailData.type == 2">
          <div class="write-txt write-item">
            <p class="write-title">
              演讲文件<span>*</span>
            </p>
            <div class="write-text">
              <video :src="'https://pic.speechcoach.cn/'+detailData.audio" controls></video>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              简易报告<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('1','1')">测试提示词</button>
              </div>
            </div>
            <div class="write-text">
              <textarea v-model="detailData.ai_simple_comment"></textarea>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              完整报告<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('1','2')">测试提示词</button>
              </div>
            </div>
          </div>
          <div class="write-txt">
            <div class="write-txt" v-for="(item,index) in detailData.dimension" :key="index">
              <p class="write-title">{{item.title}}<span>*</span></p>
              <div class="write-text">
                <input placeholder="" v-model="item.score">
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
          </div>
          <div class="write-txt write-item">
            <p class="write-title">
              内容分析<span>*</span>
            </p>
            <div class="write-text">
              <textarea v-model="detailData.ai_comment"></textarea>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              声音分析<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('3','3')">测试提示词</button>
              </div>
            </div>
            <div class="write-text">
              <textarea v-model="detailData.ai_audio_comment"></textarea>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              视觉分析<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('2','4')">测试提示词</button>
              </div>
            </div>
            <div class="write-text">
              <textarea v-model="detailData.ai_video_comment"></textarea>
            </div>
          </div>
          
        </form>
        <form v-if="detailData.speech_type == 6">
          <div class="write-txt write-item">
            <p class="write-title">
              原稿件<span>*</span>
            </p>
            <div class="write-text">
              <p class="write-comment">{{detailData.content}}</p>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              稿件改写<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('1','1')">测试提示词</button>
              </div>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-comment write-comment1"> {{detailData.ai_comment}}</p>
          </div>
        </form>
        <form v-if="detailData.speech_type == 8 || detailData.speech_type == 9 && detailData.type == 3">
          <div class="write-txt write-item">
            <p class="write-title">
              原稿件<span>*</span>
            </p>
            <div class="write-text">
              <p class="write-comment">{{detailData.content}}</p>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              报告<span>*</span>
              <div class="write-btnlist">
                <button class="btn btn-test" @click="testPrompt('1','2')">测试提示词</button>
              </div>
            </div>
          </div>
          <div class="write-txt">
            <div class="write-txt" v-for="(item,index) in detailData.dimension" :key="index">
              <p class="write-title">{{item.title}}<span>*</span></p>
              <div class="write-text">
                <input placeholder="" v-model="item.score">
                <span>最多输入30个以内的中文</span>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">总分<span>*</span></p>
              <div class="write-text">
                <input placeholder="" v-model="detailData.total_score">
              </div>
            </div>
          </div>
          <div class="write-txt write-item">
            <p class="write-title">
              内容分析<span>*</span>
            </p>
            <div class="write-text">
              <textarea v-model="detailData.ai_comment"></textarea>
            </div>
          </div>
        </form>
        <div class="btnBox">
          <!-- <button class="btn btn-sub" @click="saveSub">确认</button> -->
          <button class="btn btn-close" @click="closeSub('add')">取消</button>
        </div>
      </div>
      <div class="MobelBox" v-if="testType" v-loading="loading" :element-loading-text="loadTxt">
        <form v-if="testObj.mode == '111'">
          <div class="write-txt write-item">
            <p class="write-title">
              演讲简易报告提示词<span>*</span>
            </p>
            <div class="write-text" v-if="detailData.speech_type == 6&&detailData.is_annotation == 1">
              <textarea v-model="testData.ai_prompt_two"></textarea>
            </div>
            <div class="write-text" v-else-if="testData.speech_type == 6 || testData.speech_type == 8">
              <textarea v-model="testData.ai_prompt"></textarea>
            </div>
            <div class="write-text" v-else>
              <textarea v-model="testData.ai_prompt_simple"></textarea>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              <div class="write-btnlist">
                <button class="btn btn-test" @click="startTest">开始测试</button>
                <button class="btn btn-test" @click="saveSub">保存提示词</button>
              </div>
            </div>
          </div>
          <div class="write-txt write-item" v-if="aiTxt">
            <p class="write-title">
              AI返回结果<span>*</span>
            </p>
            <div class="write-text">
              <textarea v-model="aiTxt"></textarea>
            </div>
          </div>
        </form>
        <form v-if="testObj.mode == '121'">
          <div class="write-txt write-item">
            <p class="write-title">
              演讲简易报告提示词<span>*</span>
            </p>
            <div class="write-text" v-if="testData.is_annotation == 1">
              <textarea v-model="testData.ai_prompt_two_english"></textarea>
            </div>
            <div class="write-text" v-else>
              <textarea v-model="testData.ai_prompt_simple_english"></textarea>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              <div class="write-btnlist">
                <button class="btn btn-test" @click="startTest">开始测试</button>
              </div>
            </div>
          </div>
          <div class="write-txt write-item" v-if="aiTxt">
            <p class="write-title">
              AI返回结果<span>*</span>
            </p>
            <div class="write-text">
              <textarea v-model="aiTxt"></textarea>
            </div>
          </div>
        </form>
        <form v-if="testObj.mode == '112' || testObj.mode == '122'">
          <div class="write-txt write-item">
            <p class="write-title">
              演讲完整报告提示词<span>*</span>
            </p>
            <div class="write-text" v-if="testObj.mode == '112'">
              <textarea v-model="testData.ai_prompt"></textarea>
            </div>
            <div class="write-text" v-if="testObj.mode == '122'">
              <textarea v-model="testData.ai_prompt_english"></textarea>
            </div>
          </div>
          <div class="write-txt" v-if="testObj.mode == '112'">
            <div class="write-txt" v-for="(item,index) in testData.dimension" :key="index">
              <p class="write-title">维度{{(index+1)}}<span>*</span></p>
              <div class="write-text">
                <input placeholder="" v-model="testData.dimension[index]">
              </div>
            </div>
          </div>
          <div class="write-txt" v-if="testObj.mode == '122'">
            
            <div class="write-txt" v-for="(item,index) in testData.dimension_english" :key="index">
              <p class="write-title">维度{{(index+1)}}<span>*</span></p>
              <div class="write-text">
                <input placeholder="" v-model="testData.dimension_english[index]">
              </div>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              <div class="write-btnlist">
                <button class="btn btn-test" @click="startTest">开始测试</button>
              </div>
            </div>
          </div>
          <div class="write-txt write-item" v-if="aiTxt">
            <p class="write-title">
              AI返回结果<span>*</span>
            </p>
            <div class="write-text">
              <textarea v-model="aiTxt"></textarea>
            </div>
          </div>
          
        </form>
        <form v-if="testObj.mode == '31' || testObj.mode == '32' || testObj.mode == '211' || testObj.mode == '212' || testObj.mode == '221'">
          <div class="write-txt write-item">
            <p class="write-title">
              演讲报告提示词<span>*</span>
            </p>
            <div class="write-text" v-if="testObj.mode == '32' || testObj.mode == '221'">
              <textarea v-model="testData.ai_prompt_english"></textarea>
            </div>
            <div class="write-text" v-else>
              <textarea v-model="testData.ai_prompt"></textarea>
            </div>
          </div>
          <div class="write-txt write-item">
            <div class="write-title">
              <div class="write-btnlist">
                <button class="btn btn-test" @click="startTest">开始测试</button>
              </div>
            </div>
          </div>
          <div class="write-txt write-item" v-if="aiTxt">
            <p class="write-title">
              AI返回结果<span>*</span>
            </p>
            <div class="write-text">
              <textarea v-model="aiTxt"></textarea>
            </div>
          </div>
        </form>
        <div class="btnBox">
          <!-- <button class="btn btn-sub" @click="saveSub">确认</button> -->
          <button class="btn btn-close" @click="closeSub('test')">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="searchBox clear">
            <div class="search-item">
              <p>演讲类型：</p>
              <el-select v-model="obj.speech_type" placeholder="请选择">
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="search-item" v-if="type!='info'">
              <p>用户手机号：</p>
              <input type="text" placeholder="请输入手机号" v-model="obj.mobile">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list" :class="type=='info'?'list1':''">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList" v-if="type == 'info'">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.theme">{{item.theme}}</p>
              <p :title="item.total_score">{{item.total_score}}</p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="查看" @click="reviseShow(item)" class="btn btn-revise">查看</button>
              </p>
            </div>
          </div>
          <div class="dataList" v-else>
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.account">{{item.account}}</p>
              <p :title="item.theme">{{item.theme}}</p>
              <p :title="item.total_score">{{item.total_score}}</p>
              <!-- <p :title="item.speech_type==1?'费曼演讲':item.speech_type==2?'30秒黄金自我介绍':item.speech_type==3?'备稿演讲':item.speech_type==4?'即兴演讲':item.speech_type==5?'演讲评估':item.speech_type==6?'AI改稿':item.speech_type==7?'读稿':item.speech_type==8?'AI评估稿件':'上传演讲'">{{item.speech_type==1?'费曼演讲':item.speech_type==2?'30秒黄金自我介绍':item.speech_type==3?'备稿演讲':item.speech_type==4?'即兴演讲':item.speech_type==5?'演讲评估':item.speech_type==6?'AI改稿':item.speech_type==7?'读稿':item.speech_type==8?'AI评估稿件':'上传演讲'}}</p> -->
              <p :title="item.add_time">{{item.add_time}}</p>
              <p>
                <button title="查看" @click="reviseShow(item)" class="btn btn-revise">查看</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv" style="height: auto;">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="closeSub">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>

    <!-- 视觉分析--判断is_close_eyes和language -->
    <!-- is_annotation == 1 取值 ai_prompt_two -->
  </div>
</template>
<script>

import { getSpeechRecordList, saveVip ,getSpeechHistoryDetail,getSpeechAiPromptDetail,addAiPromptTest,saveSpeechAiPrompt} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "speechList",
  data() {
    return {
      navId:'',
      childrenID:'',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'演讲标题'},
        {id:3,title:'点评分数'},
        // {id:4,title:'演讲类型'},
        {id:5,title:'演讲时间'},
        {id:6,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      obj:{
        page:1,
        rows:10,
        speech_type:4
      },
      addObj:{
        
      },
      statusList:[
        {id:4,title:'即兴演讲',value:4},
        {id:3,title:'备稿演讲',value:3},
        {id:2,title:'30秒黄金自我介绍',value:2},
        {id:1,title:'费曼练习',value:1},
        {id:5,title:'演讲评估',value:5},
        {id:7,title:'读稿',value:7},
        {id:6,title:'AI改稿',value:6},
        {id:8,title:'评估稿件--点评',value:8},
        {id:9,title:'上传演讲',value:9},
      ],
      totalPage:0,
      token:'',
      removeID:'',
      detailData:'',
      testType:false,
      testData:'',
      testObj:{
        speech_id:'',
        speech_type:'',
        type:'',
        mode:'',
        ai_prompt:'',
      },
      aiTxt:'',
      loading:false,
      loadTxt:'',
      type:'',
      duration:0,
      durationTotal:0,
      audioType:''
    };
  },
  created(){
    this.type = this.$route.query.type;
    if(this.type == 'info'){
      this.titleList = [
        {id:1,title:'序号'},
        {id:2,title:'演讲标题'},
        {id:3,title:'点评分数'},
        {id:5,title:'演讲时间'},
        {id:6,title:'操作'},
      ];
      this.navId = '7'
    } else {
       this.titleList = [
        {id:1,title:'序号'},
        {id:4,title:'用户'},
        {id:2,title:'演讲标题'},
        {id:3,title:'点评分数'},
        {id:5,title:'演讲时间'},
        {id:6,title:'操作'},
      ]
      this.navId = '23';
    }
  },
  components: {
    navBox,
    myHeader
  },
  watch: {
    '$route'(to, from) {
      // 在这里你可以访问新的路由对象 to 和旧的路由对象 from
      console.log('新的路由', to);
      console.log('旧的路由', from.query);
      if(from.query.type == 'info'){
        window.location.reload();
      }
    }
  },
  mounted(){
    this.token = localStorage.getItem('token');
    console.log(this.type,'type')
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
        speech_type:4
      };
      this.addObj = {}
      this.dataList = [];
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getSpeechRecordList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.publish_status==0){
              item.publish_status=false
            } else {
              item.publish_status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      this.addType = 'add';
    },

    async saveSub(){
      var that = this;
      var obj = {
        id:this.testData.id,
      }
      if(this.testObj.mode == '111'){
        if(this.detailData.speech_type == 6 && this.detailData.is_annotation==1){
          obj.ai_prompt_simple = this.testData.ai_prompt_two
        } else {
          obj.ai_prompt_simple = this.testData.ai_prompt
        }
      } else if(this.testObj.mode == '112'){
        obj.ai_prompt = this.testData.ai_prompt
        obj.dimension = this.testData.dimension
      } else if(this.testObj.mode == '121'){
        if(this.detailData.speech_type == 6 && this.detailData.is_annotation==1){
          obj.ai_prompt_simple_english = this.testData.ai_prompt_two_english
        } else {
          obj.ai_prompt_simple_english = this.testData.ai_prompt_simple_english
        }
      } else if(this.testObj.mode == '122'){
        obj.ai_prompt = this.testData.ai_prompt_english
        obj.dimension = this.testData.dimension_english
      } else if(this.testObj.mode == '31' || this.testObj.mode == '211'){
        obj.ai_prompt = this.testData.ai_prompt
      } else if(this.testObj.mode == '32' || this.testObj.mode == '221'){
        obj.ai_prompt = this.testData.ai_prompt_english
      } else if(this.testObj.mode == '212'){
        obj.ai_prompt_two = this.testData.ai_prompt_two
      } else if(this.testObj.mode == '222'){
        obj.ai_prompt_two_english = this.testData.ai_prompt_two_english
      } 
      console.log(obj)
      try {
        const response = await savesaveSpeechAiPromptVip(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.addType = '';
          that.testType = false;
          that.resetSub(); 
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async reviseShow(e){
      var that = this;
      try {
        const response = await getSpeechHistoryDetail({speech_id:e.speech_id,speech_type:this.obj.speech_type},this.token);
        if(response.code == 200){
          that.addType = 'add'
          that.detailData = response.data;
          setTimeout(function(){
          that.getDuration();
          },1000)
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    playAudio() {
      if(this.audioType == 'play'){
        this.$refs.audioPlayer.pause(); // 播放音频
        this.audioType = 'pause';
      } else {
        this.$refs.audioPlayer.play(); // 播放音频
        this.audioType = 'play';
        this.$refs.audioPlayer.play().catch(error => {
          console.error('播放失败:', error);
        });
      }
      
    },

    getDuration() {
      const audio = this.$refs.audioPlayer;
      if (audio.readyState >= 2) { // readyState >= 2 表示元数据已加载
        this.duration = audio.duration; // 获取音频时长并更新到data中
      } else {
        // 如果尚未加载元数据，则稍后尝试获取时长
        audio.addEventListener('loadedmetadata', () => {
          this.duration = audio.duration; // 获取音频时长并更新到data中
        });
      }
      this.durationTotal = this.duration;
      this.duration = this.convertSecondsToFormattedString(parseInt(this.duration));
    },

    updateDuration() {
      var that = this;
      // 使用ref引用获取到audio DOM元素
        const audio = that.$refs.audioPlayer;
        // 更新时长数据属性
        // that.duration = audio.duration; // 获取总时长（秒）
        var time = that.durationTotal;
        console.log(time,'audio')
        that.duration = that.convertSecondsToFormattedString(parseInt(time - audio.currentTime)) ;
      
    },

    audioEnd(){
      this.audioType = '';
      this.duration = this.convertSecondsToFormattedString(parseInt(this.durationTotal));
    },

    convertSecondsToFormattedString(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    },

    removeShow(e){
      var that = this;
      this.removeType = true;
      this.removeID = e.id;
    },

    async removeSub(e){
      var that = this;
      try {
        const response = await delVip({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('成功');
          that.removeType = '';
          that.resetSub();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(type){
      if(type == 'add'){
        this.addType = ''
      } else if(type == 'test'){
        this.addType = 'add';
        this.testType = false;
      }
      this.removeType = false;
      // this.addType = '';
      this.addObj = {};
      this.removeID = '';
    },
    
    async testPrompt(type,e){
      var that = this;
      var obj = {
        speech_type:this.detailData.speech_type,
        type:type
      };
      try {
        const response = await getSpeechAiPromptDetail(obj,this.token);
        if(response.code == 200){
          that.testType = true;
          that.addType = '';
          that.testData = response.data;
          // 文本
          // 111：中文-简易 
          // 112：中文-完整 
          // 121：英文-简易 
          // 122：英文-完整 （ai改稿属于简易，ai评估属于完整） 
          // 视频
          // 211：中文-非闭眼 
          // 212：中文-闭眼 
          // 221：英文-非闭眼 
          // 222：英文-闭眼 
          // 录音
          // 31：中文 
          // 32：英文
          
          if(that.detailData.language == 1){
            if(type == 1){
              if(e == 1){
                that.testObj.mode = '111'
              } else {
                that.testObj.mode = '112'
              }
            } else if(type == 2){
              if(that.detailData.is_close_eyes == 0){
                that.testObj.mode = '211'
              } else if(that.detailData.is_close_eyes == 1){
                that.testObj.mode = '212'
              }
            } else if(type == 3){
                that.testObj.mode = '31'
            }
          } 
          else if(that.detailData.language == 2){
            if(type == 1){
              if(e == 1){
                that.testObj.mode = '121'
              } else {
                that.testObj.mode = '122'
              }
            } else if(type == 2){
              if(that.detailData.is_close_eyes == 0){
                that.testObj.mode = '221'
              } else if(that.detailData.is_close_eyes == 1){
                that.testObj.mode = '222'
              }
            } else if(type == 3){
                that.testObj.mode = '32'
            }
          } else {
            if(e == 1){
              that.testObj.mode = '111'
            } else {
              that.testObj.mode = '112'
            }
          };
          console.log(that.testObj.mode,'mode')
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async startTest(e){
      var that = this;
      this.testObj.speech_id=that.detailData.speech_id;
      this.testObj.speech_type=that.testData.speech_type;
      this.testObj.type=that.testData.type;
      if(this.testObj.mode == '112'){
        this.testObj.ai_prompt=that.testData.ai_prompt;
        this.testObj.dimension = that.testData.dimension
      } else if(this.testObj.mode == '31'){
        this.testObj.ai_prompt=that.testData.ai_prompt;
      } else if(this.testObj.mode == '32' || this.testObj.mode == '221'){
        this.testObj.ai_prompt=that.testData.ai_prompt_english;
      } else if(this.testObj.mode == '121'){
        this.testObj.ai_prompt=that.testData.ai_prompt_simple_english;
      } else if(this.testObj.mode == '122'){
        this.testObj.ai_prompt=that.testData.ai_prompt_english;
        this.testObj.dimension = that.testData.dimension_english
      } else if(this.testObj.mode == '211'){
        this.testObj.ai_prompt=that.testData.ai_prompt;
      } else if(this.testObj.mode == '212'){
        this.testObj.ai_prompt=that.testData.ai_prompt;
      } else {
        if(this.testData.speech_type == '6' || this.testData.speech_type == '8'){
          this.testObj.ai_prompt=that.testData.ai_prompt;
        } else {
          this.testObj.ai_prompt=that.testData.ai_prompt_simple;
        }
      }
      
      this.loading = true;
      this.loadTxt = 'ai生成中，请稍后......'
      console.log(that.testObj);
      try {
        const response = await addAiPromptTest(this.testObj,this.token);
        if(response.code == 200){
          that.aiTxt = response.data.ai_comment;
        } else {
          that.$message(response.msg);
        }
        that.loading = false;
        that.loadTxt = '';
      } catch (error) {
        that.$message(error);
        that.loading = false;
        that.loadTxt = '';
      }
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 6 );
  }

  .list1 .dataList .listItem p, 
  .list1 .titleList p,
  .list1 .organiza-list p{
    width: calc( 100% / 5 );
  }

  .btn-remove,
  .btn-revise{
    display: inline-block;
    vertical-align: top;
  }

  .searchBox{
    margin-top: 0;
  }

  .MobelBox{
    margin: 20px;
    box-sizing: border-box;
    height: calc( 100% - 120px );
    display: block;
  }

  .MobelBox form{
    background-color: #fff;
    padding: 30px;
    box-sizing: border-box;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    /* width: 200px; */
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text video{
    width: 400px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .write-comment{
    color: #333333;
    font-size: 18px;
  }

  .write-comment1{
    display: block;
    background-color: #F5F5F5;
    border-radius: 16px;
    padding: 20px;
    box-sizing: border-box;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .MobelBox input{
    width: 360px;
    height: 65px;
  }

  .MobelBox textarea{
    height: 450px;
  }

  .MobelBox input.vip_time{
    display:inline-block;
    width: 120px;
    padding: 0 10px;
    margin-right: 20px;
  }

  .MobelBox .btnBox{
    display: block;
    margin-top: 30px;
    text-align: right;
    margin-right: 40px;
  }

  .MobelBox .btnBox .btn{
    font-size: 20px;
    color: #999999;
    box-sizing: border-box;
    padding: 14px 40px;
    border-radius: 16px;
    display: inline-block;
    vertical-align: top;
    background-color: #F9F9F9;
  }

  .MobelBox .btnBox .btn.btn-sub{
    background-color: #6E2FFF;
    color: #fff;
    margin-right: 40px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .searchBox>>>.search-item input{
    width: 160px;
  }

  .msgBox .contv{
    height: 80%;
  }

  .msgBox .btnBox{
    margin-top: 50px;
  }

  .msgBox>>>.el-radio__label{
    font-size: 15px;
  }
  .msgBox>>>.el-radio-group .el-radio{
    line-height: 30px;
  }

  .write-txt>>> .el-radio__inner{
    width: 20px;
    height: 20px;
  }

  .write-txt>>> .el-radio__inner::after{
    width: 10px;
    height: 10px;
  }

  .write-txt>>> .el-radio__label{
    font-size: 18px;
    vertical-align: top;
  }

  .write-txt>>> .el-radio-group{
    display: inline-block;
    vertical-align: top;
    line-height: 65px;
  }

  .MobelBox .write-item .write-text{
    display: block;
    margin: 20px 0 0;
  }

  .MobelBox .write-item .write-btnlist{
    display: inline-block;
    vertical-align: top;
    margin-left: 30px;
  }

  .MobelBox .write-item .write-btnlist .btn{
    width: 117px;
    height: 40px;
    font-size: 18px;
    color: #fff;
    background-color: #6E2FFF;
    border-radius: 6px;
    display: inline-block;
    vertical-align: top;
    margin: 0 10px;
    border: solid 1px transparent;
  }

  .MobelBox .write-item .write-btnlist .btn.btn-history{
    color: #6E2FFF;
    background-color: transparent;
    border: solid 1px #6E2FFF;
  }

  .audio-bg{
    background-color: #BC9FFF;
    border-radius: 45px;
    width: 405px;
    height: 70px;
    padding: 24px 30px;
    box-sizing: border-box;
  }

  .audio-bg i{
    width: 4px;
    height: 24px;
    border-radius: 2px;
    display: inline-block;
    vertical-align: top;
    margin-right: 5px;
    background-color: #fff;
  }

  .audio-bg p{
    color: #fff;
    font-size: 20px;
    display: inline-block;
    vertical-align: top;
    line-height: 24px;
    height: 24px;
    margin-left: 20px;
  }

  .MobelBox .write-text span.audio-type{
    width: 40px;
    height: 40px;
    background-size: 40px 40px;
    display: inline-block;
    vertical-align: middle;
    margin-top: -8px;
    margin-left: 10px;
  }

  .MobelBox .write-text span.audio-type.play{
    background-image: url(~@/assets/images/icon-play.png);
  }
  .MobelBox .write-text span.audio-type.pause{
    background-image: url(~@/assets/images/icon-pause.png);
  }

  .audio-bg i.audio-progress1{
    background-image: url(~@/assets/images/icon-progress.gif);
    width: 221px;
    height: 30px;
    background-size: 221px 30px;
    display: inline-block;
    vertical-align: top;
    margin: 0;
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/user/list.vue